module.exports = __webpack_public_path__ + "static/img/zavod_za_javno_zdravlje_subotica.4566dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/zavod_za_javno_zdravlje_subotica.jpg
// module id = CrP1
// module chunks = 0